import { StoriesFilter } from './Stories.types';

export const setURLfromFilters = (f: Omit<StoriesFilter, 'page'>) => {
  const url = new URL(window.location.href);
  url.searchParams.set('country', f.country?.toString() || '0');
  url.searchParams.set('industry', f.industry?.toString() || '0');
  url.searchParams.set('subIndustry', f.subIndustry?.toString() || '0');
  window.history.pushState({}, null, url);
};

export const getFiltersFromURL = (): Omit<StoriesFilter, 'page'> => {
  const url = new URL(window.location.href);

  return {
    country: +url.searchParams.get('country') || 0,
    industry: +url.searchParams.get('industry') || 0,
    subIndustry: +url.searchParams.get('subIndustry') || 0,
  };
};
